import { render, staticRenderFns } from "./CPMissingDocumentSummary.vue?vue&type=template&id=5a0d5592&scoped=true&"
import script from "./CPMissingDocumentSummary.vue?vue&type=script&lang=ts&"
export * from "./CPMissingDocumentSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CPMissingDocumentSummary.vue?vue&type=style&index=0&id=5a0d5592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d5592",
  null
  
)

export default component.exports